import { useContext } from "react";
import { useStore } from "zustand";
import { FormStoresContext } from "@/components/forms/context/formStoresContext";
import { FormData } from "@/components/forms/store/useFormData";
import { FormState } from "@/components/forms/store/useFormState";

// Hook to consume the scoped store
export const useFormDataStore = () => {
	const store = useContext(FormStoresContext);
	if (!store)
		throw new Error(
			"useFormDataStore must be used inside FormContextProvider"
		);
	return useStore(store.formDataStore);
};

export const useFormStateStore = () => {
	const store = useContext(FormStoresContext);
	if (!store)
		throw new Error(
			"useFormStateStore must be used inside FormContextProvider"
		);
	return useStore(store.formStateStore);
};
